export const SESSION_TIMEOUT_MS = 30 * 60 * 1000
export const LAST_ACTIVITY_KEY = 'lastActivityAt'

const ADMIN_ACCOUNT_TYPES = ['admin', 'super_admin', 'agent']

export function isCustomerAccount(accountType?: string): boolean {
  if (!accountType) return true
  return !ADMIN_ACCOUNT_TYPES.includes(accountType)
}

export function getLastActivityAt(): number | null {
  const raw = localStorage.getItem(LAST_ACTIVITY_KEY)
  if (!raw) return null
  const timestamp = parseInt(raw, 10)
  return Number.isNaN(timestamp) ? null : timestamp
}

export function setLastActivityAt(timestamp = Date.now()): void {
  localStorage.setItem(LAST_ACTIVITY_KEY, String(timestamp))
}

export function clearLastActivityAt(): void {
  localStorage.removeItem(LAST_ACTIVITY_KEY)
}

export function isSessionExpired(): boolean {
  const lastActivity = getLastActivityAt()
  if (!lastActivity) return false
  return Date.now() - lastActivity >= SESSION_TIMEOUT_MS
}
